<template>
    <div id="animated-header">
        <div
            id="animated-header-names-wrapper"
            class="text-yanone text-uppercase"
            :class="{ animate }"
        >
            <div class="animated-header-names">
                <template v-for="index in elementsCount">
                    <span>{{ labels[index % labels.length] }}</span>
                </template>
            </div>
            <div class="animated-header-names">
                <template v-for="index in elementsCount">
                    <span>{{ labels[(elementsCount - index) % labels.length] }}</span>
                </template>
            </div>
        </div>

        <div v-if="showOverlay" id="animated-header-overlay"></div>
        <div class="animated-header-slot">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AnimatedHeader',

        props: {
            animate: {
                type: Boolean,
                default: true,
            },
            labels: Array,
            showOverlay: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return { elementsCount: 250 };
        },
    };
</script>
